import { render, staticRenderFns } from "./DoctorProfile.vue?vue&type=template&id=001e3455&"
import script from "./DoctorProfile.vue?vue&type=script&lang=js&"
export * from "./DoctorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports